<template>
  <div v-if="getTags.length>0">
    <Tag 
     v-for="(item,index) in getTags" :key="index" 
    type="dot" name="1" closable checkable
    :color="getCheckId == item.id?'primary':'#ddd'"
     @on-close="closeTag(item.id)"
     @on-change="changeTag(item.id)">
    {{item.name}}</Tag>
  </div>
</template>
<script>
import {mapGetters} from "vuex"
export default {
  mounted(){
    console.log(this.getTags);
    
  },
  methods: {
    closeTag(id) {
      if(this.getTags.length>1){
        this.$store.commit('closeTags',id)
        let menus = this.$store.state.menus;
        let index = this.$store.state.checkId;
        this.$store.commit('setCheckMenu',index)
        console.log(index);
        let url = menus[index-1].url;
        this.$router.push({path:url});
      }
      // console.log(this.$store.state.checkId);
    },
    changeTag(c){
     this.$store.commit('setCheckId',c)
     this.$store.commit('setCheckMenu',c)
     
     console.log(c)
     console.log(this.$store.state.menus);
     console.log(this.$store.state.checkMenu)

     let menus = this.$store.state.menus;
     for(let m of menus){
       if(m.id==c){
         let url = m.url;
         this.$router.push({path:url});
       }
     }
    }
  },
  computed:{
    ...mapGetters(['getTags','getCheckId'])
  },
};
</script>
<style scoped>
.ivu-layout>div:first-child{
  background-color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/views/index/YnTags.vue